
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about_45a3p5JmeKN8_GiQcw0sJerbXQUCh_45monxcEfVApeZrMMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/about.vue?macro=true";
import { default as compressOMgiPTcTUe7AdWEpuwSlO19nh_w4O5Kg5xwZGV91jUsMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/compress.vue?macro=true";
import { default as filterSLwsqPU6Rn2Q2WaPUDt6LYFMas72oaFsVEj1UWVEpocMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/filter.vue?macro=true";
import { default as imgATdMRPDoTQ52gVO9_u6AmrBvqqnxg5R_sjEF4GeUeX0Meta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/img.vue?macro=true";
import { default as indexK2wIOhoy6AIMaDfV5nqFC3tr_45sUjBOXt_45FEc6hqxY5MMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/index.vue?macro=true";
import { default as jigsawaRgMT3dbIYW_457fyuNsxoMaAgtTMe_45tOtzA7uh9RWnBgMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/jigsaw.vue?macro=true";
import { default as reverseCQMkEpLvd5yZZxLmhSnQU8_45oZv90CgBGxMlVNuqzefQMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/reverse.vue?macro=true";
import { default as scalesY_Zl10HL6orTC8UBeVU2Xo2QLN3LXHikWTbCG4ecQEMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/scale.vue?macro=true";
import { default as transformAnXkwe0htcN5_45jvIID95p_45W_45dzmEX0tI4V6eyoa401sMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/transform.vue?macro=true";
import { default as watermarkEwwYahMwuPfQtgL_RQx_45ifcfRhLtLu8LJp1LMhUvbI0Meta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/watermark.vue?macro=true";
import { default as wordmBsprkyG4a6SuqDS32Vs8pA9YqcIRGPBO47qQmB2omYMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/word.vue?macro=true";
import { default as indexPW_yYeXnfrhcGC7qE2d4DCn7YFU6fCOMNgyubTcJBmYMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/index.vue?macro=true";
import { default as indexK9P4uHOyFQlyt_45lP0_454Faqm0Kqja2yATY1sK3ZrXwEsMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/to_gif/index.vue?macro=true";
import { default as picturegA38m3W1cBeBtXTwcFGwFWUcwgOuhT5iFtaos6b2H14Meta } from "/root/workspace/easygif-nuxt_6hOg/pages/to_gif/picture.vue?macro=true";
import { default as screenrecordem6OrrJ_iCYUIZCyOMgIRnohnISJyy6WBLknuXFp3wAMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/to_gif/screenrecord.vue?macro=true";
import { default as videoYMS8pIZHdVY0DGT5uKJYFI30kjhNAemaIulnJOK7NBwMeta } from "/root/workspace/easygif-nuxt_6hOg/pages/to_gif/video.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: about_45a3p5JmeKN8_GiQcw0sJerbXQUCh_45monxcEfVApeZrMMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/about.vue")
  },
  {
    name: "gif_modify-compress",
    path: "/gif_modify/compress",
    meta: compressOMgiPTcTUe7AdWEpuwSlO19nh_w4O5Kg5xwZGV91jUsMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/compress.vue")
  },
  {
    name: "gif_modify-filter",
    path: "/gif_modify/filter",
    meta: filterSLwsqPU6Rn2Q2WaPUDt6LYFMas72oaFsVEj1UWVEpocMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/filter.vue")
  },
  {
    name: "gif_modify-img",
    path: "/gif_modify/img",
    meta: imgATdMRPDoTQ52gVO9_u6AmrBvqqnxg5R_sjEF4GeUeX0Meta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/img.vue")
  },
  {
    name: "gif_modify",
    path: "/gif_modify",
    meta: indexK2wIOhoy6AIMaDfV5nqFC3tr_45sUjBOXt_45FEc6hqxY5MMeta || {},
    redirect: "/gif_modify/transform",
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/index.vue")
  },
  {
    name: "gif_modify-jigsaw",
    path: "/gif_modify/jigsaw",
    meta: jigsawaRgMT3dbIYW_457fyuNsxoMaAgtTMe_45tOtzA7uh9RWnBgMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/jigsaw.vue")
  },
  {
    name: "gif_modify-reverse",
    path: "/gif_modify/reverse",
    meta: reverseCQMkEpLvd5yZZxLmhSnQU8_45oZv90CgBGxMlVNuqzefQMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/reverse.vue")
  },
  {
    name: "gif_modify-scale",
    path: "/gif_modify/scale",
    meta: scalesY_Zl10HL6orTC8UBeVU2Xo2QLN3LXHikWTbCG4ecQEMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/scale.vue")
  },
  {
    name: "gif_modify-transform",
    path: "/gif_modify/transform",
    meta: transformAnXkwe0htcN5_45jvIID95p_45W_45dzmEX0tI4V6eyoa401sMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/transform.vue")
  },
  {
    name: "gif_modify-watermark",
    path: "/gif_modify/watermark",
    meta: watermarkEwwYahMwuPfQtgL_RQx_45ifcfRhLtLu8LJp1LMhUvbI0Meta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/watermark.vue")
  },
  {
    name: "gif_modify-word",
    path: "/gif_modify/word",
    meta: wordmBsprkyG4a6SuqDS32Vs8pA9YqcIRGPBO47qQmB2omYMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/gif_modify/word.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexPW_yYeXnfrhcGC7qE2d4DCn7YFU6fCOMNgyubTcJBmYMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/index.vue")
  },
  {
    name: "to_gif",
    path: "/to_gif",
    meta: indexK9P4uHOyFQlyt_45lP0_454Faqm0Kqja2yATY1sK3ZrXwEsMeta || {},
    redirect: "/to_gif/picture",
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/to_gif/index.vue")
  },
  {
    name: "to_gif-picture",
    path: "/to_gif/picture",
    meta: picturegA38m3W1cBeBtXTwcFGwFWUcwgOuhT5iFtaos6b2H14Meta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/to_gif/picture.vue")
  },
  {
    name: "to_gif-screenrecord",
    path: "/to_gif/screenrecord",
    meta: screenrecordem6OrrJ_iCYUIZCyOMgIRnohnISJyy6WBLknuXFp3wAMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/to_gif/screenrecord.vue")
  },
  {
    name: "to_gif-video",
    path: "/to_gif/video",
    meta: videoYMS8pIZHdVY0DGT5uKJYFI30kjhNAemaIulnJOK7NBwMeta || {},
    component: () => import("/root/workspace/easygif-nuxt_6hOg/pages/to_gif/video.vue")
  }
]